import React from "react";
import "../Playlists/styles.scss";
import _ from "lodash";
import FullPageSpinner from "../../../../FullPageSpinner";
import { indexSingles, removeMediumFromSingle } from "../../../../../api/sound_tracks";
// import Pagination from "../../../../shared/Pagination";
import { isSelfId } from "../../../../../api/helper";
import { ReactComponent as NewAlbumIcon } from "../../../../../public/icons/UserProfile/newPlaylist.svg";
import MediaFlatItemSingle from '../../../../shared/MediaFlatitemsingle';
import hv_player_api from '../../../../../api/hv_player_api';
import RemoveSinglesConfimModal from "./RemoveSinglesConfimModal";
import { shuffle } from "lodash";

export default class Singles extends React.Component {

  state = {
    soundtracks: null,
    meta: null,
    page_number: 0,
    page_size: 10,
    showConfirmModal: false,
    medium_id: null,
  };


  showConfirmation() {
    this.setState({ showConfirmModal: true })
  };

  componentDidMount() {
    this.indexSingles();
  }

  componentDidUpdate(prevProp, prevState) {
    if (
      prevState.page_number !== this.state.page_number ||
      prevState.page_size !== this.state.page_size
    )
      this.indexSingles();
  }

  indexSingles = async () => {
    this.setState({ soundtracks: null });
    let {
      data: { soundtracks, meta },
    } = await indexSingles({
      page_number: this.state.page_number,
      page_size: this.state.page_size,
      filter: { user_id: this.props.user.id },
    });
    this.setState({ soundtracks, meta });
    try {
      if (this.state.soundtracks.length) {
        const shuffledMedia = shuffle(this.state.soundtracks);
        hv_player_api.setQueueMedia({
          type: "Hash",
          current_track_index: 0,
          loaded_media: shuffledMedia,
          queue: shuffledMedia.map((m) => m.id),
        });
        hv_player_api.setCurrentlyPlayingTrack(shuffledMedia[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  updateSingles = (medium) => {
    const updatedSoundtrack = this.state.soundtracks.map((om) => (medium.id === om.id ? medium : om))
    this.setState({ soundtracks: updatedSoundtrack });
  };

  onRemoveMedium = (medium) => {
    this.showConfirmation()
    this.setState({medium_id: medium.id})
  }

  removeMedium = async () => {
    try {
      await removeMediumFromSingle(this.state.medium_id);
      this.indexSingles();
      this.setState({ showConfirmModal: false })
    } catch (error) {}
  }

  changePage = page_number => this.setState({ page_number });
  changePageSize = page_size => this.setState({ page_size });

  sort = (tracks) => {
      return tracks.sort((a,b) => {
        return new Date(a.release_date).getTime() - 
          new Date(b.release_date).getTime()
    }).reverse();
  }
  
  render() {
    return (
      <div className="profile-playlists m-4">
        {_.isNull(this.state.soundtracks) ? (
          <FullPageSpinner />
        ) : (
          <>
            <div className="single-view">
              {this.sort(this.state.soundtracks).map(medium => (
                <MediaFlatItemSingle
                  media={this.state.soundtracks}
                  key={medium.id.toString()}
                  eventKey={medium.id.toString()}
                  activeEventKey={medium.id.toString()}
                  source={{ id: medium?.id, type: medium?.type }}
                  sourceOwner={medium.user}
                  medium={medium}
                  setObject={this.updateSingles}
                  onRemoveMedium={this.onRemoveMedium}
                  onRemoveFromQueue={hv_player_api.removeFromQueue}
                  onAddToQueue={hv_player_api.addToQueue}
                />
              ))}
            </div>
          </>
        )}
        {/*<Pagination
                  meta={this.state.meta}
                  page={this.state.page_number}
                  pageSize={this.state.page_size}
                  changePage={this.changePage}
                  changePageSize={this.changePageSize}
                />*/}

        {this.state.showConfirmModal && (
          <RemoveSinglesConfimModal
            show={this.state.showConfirmModal}
            removeMedium={this.removeMedium}
            hide={() => this.setState({ showConfirmModal: false })}
          />
        )}
      </div>
    );
  }
}
